import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, withRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from '@client/i18n/i18n';
import {
  getMainRoutes,
  routeWithSubRoutes,
} from '@client/shared/utils/routerUtils/routerUtils';
import routes from '@client/pages/routes';
import NotificationListing from '@client/containers/notificationListing/NotificationListing';
import { selectNotifications } from '@client/redux/notification/notificationReducer';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import PublicNav from '@client/pages/landingPage/navMenu/NavMenu';
import PublicFooter from '@client/pages/landingPage/landingFooter/LandingFooter';
import AdminSidebar from '../adminSidebar/AdminSidebar';
import ErrorBoundary from './errorBoundary/ErrorBoundary';
import styles from './appFrame.scss';

const MainRouteSwitch = withRouter(() => {
  function getMainClassName() {
    return classNames({
      [styles.main]: true,
    });
  }

  return (
    <main className={getMainClassName()}>
      <I18nextProvider i18n={i18n}>
        <Switch>
          {routes.map((route, index) => routeWithSubRoutes(route, index))}
        </Switch>
      </I18nextProvider>
    </main>
  );
});

const MAIN_ROUTES = getMainRoutes();

class AppFrame extends React.PureComponent {
  showMenu = () => {
    const { location } = this.props;

    const isAdminPages = location.pathname.startsWith('/admin');
    const notLoginPage =
      !location.pathname.startsWith(MAIN_ROUTES.LOGIN.TO) &&
      !location.pathname.startsWith(MAIN_ROUTES.ADVERTISER_LOGIN.TO);
    const notReportPage =
      !location.pathname.startsWith(MAIN_ROUTES.REPORT.TO) &&
      !location.pathname.startsWith(MAIN_ROUTES.ADVERTISER_REPORT.TO);

    return notLoginPage && notReportPage && isAdminPages;
  };

  showPublicMenu = () => {
    const { location } = this.props;

    const isAdminPages = location.pathname.startsWith('/admin');
    const isAdvertiserPages = location.pathname.startsWith('/advertiser/');
    return !isAdminPages && !isAdvertiserPages;
  };

  showAdvertiserLogin = (path) => {
    return path === MAIN_ROUTES.ADVERTISER.TO;
  };

  hasWhiteLogoColor = (path) => {
    switch (path) {
      case '/':
        return false;
      case '':
        return false;
      case MAIN_ROUTES.ADVERTISER.TO:
        return true;
      case MAIN_ROUTES.TERMS.TO:
        return false;
      case MAIN_ROUTES.FAQ.TO:
        return false;
      default:
        return false;
    }
  };

  hasWhiteIconColor = (path) => {
    switch (path) {
      case '/':
        return true;
      case '':
        return true;
      case MAIN_ROUTES.ADVERTISER.TO:
        return false;
      case MAIN_ROUTES.TERMS.TO:
        return false;
      case MAIN_ROUTES.FAQ.TO:
        return false;
      default:
        return false;
    }
  };

  render() {
    const { notifications } = this.props;
    const { pathname } = this.props.location;

    return (
      <ErrorBoundary>
        <div
          className={classNames(
            styles.appFrame,
            styleHelper.projectImportanceWrapper
          )}
          id="app-container"
        >
          <div className={styles.mainContent}>
            {this.showMenu() && <AdminSidebar />}
            <div
              className={classNames(
                styles.column,
                this.showMenu() && styles.hasAdminSidebar
              )}
            >
              {this.showPublicMenu() && (
                <PublicNav
                  hasWhiteLogo={this.hasWhiteLogoColor(pathname)}
                  hasWhiteIcon={this.hasWhiteIconColor(pathname)}
                />
              )}
              <MainRouteSwitch />
              {this.showPublicMenu() && (
                <PublicFooter
                  showAdvertiserLogin={this.showAdvertiserLogin(pathname)}
                />
              )}
              {notifications && (
                <NotificationListing notifications={notifications} />
              )}
            </div>
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}

AppFrame.propTypes = {
  location: PropTypes.object,
  notifications: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    notifications: selectNotifications(state),
  };
};

export default connect(mapStateToProps)(withRouter(AppFrame));
